import React from 'react';
import PropTypes from 'prop-types';
import QuestionText from '../components/QuestionText';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '../../../components/Button.js';

const categoryOneServices = [
  'Transport',
  'Nursing Services',
  'Interpreters',
  'Cleaning',
  'Gardening',
  'Respite Accomodation',
  'Meals',
  'Day Centre',
  'Holidays and Travel',
  'Social Activities',
  'Sport and Fitness',
  'Creative Arts',
  'School Holiday Activities',
  'Physiotherapy',
  'Speech Therapy',
  'Occupational Therapy',
  'Psychology',
  'Dietetics',
  'Massage',
  'Art Therapy',
  'Music Therapy',
  'Behavioural Support',
  'Therapy Assistants',
  'Excercise Physiology',
  'Podiatry, Orthopaedics and Prosthetics',
  'Daily Living and Access',
  'Recreation and Leisure',
  'Therapy and Assessment'
];

const categoryTwoServices = [
  'Support Work'
];

const categoryOneOptions = [
  {id: 1, value: 'One-off'},
  {id: 2, value: 'Ad hoc'},
  {id: 3, value: 'Daily'},
  {id: 4, value: 'Weekly'},
  {id: 5, value: 'Fortnightly'},
  {id: 6, value: 'Monthly'},
  {id: 7, value: 'Unsure'},
];

const categoryTwoOptions = [
  {id: 1, value: 'Less than 10 hours per week'},
  {id: 2, value: '10 to 20 hours per week'},
  {id: 3, value: 'More than 20 hours per week'},
  {id: 4, value: 'Unsure'},
];

const useStyles = makeStyles(theme => ({
  service: {
    width: '100%',
    margin: 0,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    marginBottom: '1.5rem',
  },
  label: {
    width: '15rem',
    [theme.breakpoints.down('md')]: {
      width: '40%',
    },
  },
  field: {
    marginLeft: '1rem',
    minWidth: '15rem',
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down('md')]: {
      width: '50%',
    },
  },
  button: {
    padding: '1.5rem 0',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ServiceAmountQuestion = ({data, handleAnswer}) => {
  const classes = useStyles();
  const [selections, setSelections] = React.useState([]);

  const handleChange = (key, value) => {
    const updated = selections.map(item => {
      if (item.name === key) {
        return {name: item.name, amount: value};
      }
      return item;
    });
    setSelections(updated);
  };

  const validateData = () => {
    return !(selections.some(e => e.amount === ''));
  };

  const handleSubmit = () => {
    handleAnswer('services', selections);
  };

  const initialiseData = (data) => {
    // Add a field for amount, set to NA for services
    // where amount doesn't apply
    return data.services.map(item => {
      let amount;
      if ('amount' in item) {
        amount = item.amount;
      } else {
        let c1 = categoryOneServices.includes(item.name);
        let c2 = categoryTwoServices.includes(item.name);
        amount = c1 || c2 ? '' : 'NA';
      }
      return {name: item.name, amount: amount};
    });
  };

  React.useEffect(() => {
    const initialisedData = initialiseData(data);
    setSelections(initialisedData);
    // If there are only services where amount is not applicable selected,
    // then skip to the next question
    const uniqueAmounts = [...new Set(initialisedData.map(item => item.amount))];
    if (uniqueAmounts.length === 1 && uniqueAmounts[0] === 'NA') {
      handleAnswer('services', initialisedData);
    }
  }, [data, handleAnswer]);

  return (
    <React.Fragment>
      <QuestionText>
        Please indicate the amount or frequency of service you need.
      </QuestionText>
      {selections.map(item => {
        if (item.amount !== 'NA') {
          const answerOptions = categoryOneServices.includes(item.name) ? categoryOneOptions : categoryTwoOptions;
          return (
            <div key={item.name} className={classes.service}>
              <Typography variant="h3" className={classes.label}>
                {item.name}
              </Typography>
              <Select
                id={`select-input-${item.id}`}
                value={item.amount}
                className={classes.field}
                variant="outlined"
                onChange={e => handleChange(item.name, e.target.value)}
              >
                {answerOptions.map(opt => (<MenuItem key={opt.id} value={opt.value}>{opt.value}</MenuItem>))}
              </Select>
            </div>
          );
        }
        return null;
      })}
      <div className={classes.button}>
        <Button
          onClick={handleSubmit}
          label="Next"
          pointer="right"
          variant="contained"
          disabled={!validateData()}
        />
      </div>
    </React.Fragment>
  );
};

ServiceAmountQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default ServiceAmountQuestion;
